import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=65aa40ac&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65aa40ac')) {
      api.createRecord('65aa40ac', component.options)
    } else {
      api.reload('65aa40ac', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=65aa40ac&", function () {
      api.rerender('65aa40ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5dtU1ZP57HR/JS/comp/FavElement.vue"
export default component.exports